export function replaceRgbWithRgba(str: string, alpha = 0.2) {
  const rgbRegex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;

  const rgbaString = str.replace(rgbRegex, (match, r, g, b) => `rgba(${r}, ${g}, ${b}, ${alpha})`);

  return rgbaString;
}
